export default class StoreRegistry {
  static store

  static register(newStore): void {
    StoreRegistry.store = newStore
  }
}
